import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

/**
 * Upload adapter for CKEditor or similar loaders.
 * Routes through the backend /api/uploads endpoint.
 *
 * @param {File}   loader   - The File object to upload.
 * @param {string} [category="project"] - Upload category: "project" or "product".
 * @returns {string} The permanent S3 URL.
 */
export async function uploadAdapter(loader, category = "project") {
  const token = localStorage.getItem("accessToken");

  const formData = new FormData();
  formData.append("file", loader);

  try {
    const response = await axios.post(
      `${BASE_URL}api/uploads/${category}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const url = response.data?.commonResponse || response.data?.Result;

    if (!url || typeof url !== "string") {
      throw new Error("Upload succeeded but no URL was returned");
    }

    return url;
  } catch (error) {
    const serverMessage =
      error.response?.data?.message ||
      error.response?.data?.errorMessage?.[0]?.message ||
      error.message ||
      "Unknown upload error";

    console.error("Error uploading file:", serverMessage, error);
    throw new Error(serverMessage);
  }
}
